import { render, staticRenderFns } from "./EmergencyContact.vue?vue&type=template&id=1e23740c&scoped=true"
import script from "./EmergencyContact.vue?vue&type=script&lang=ts"
export * from "./EmergencyContact.vue?vue&type=script&lang=ts"
import style0 from "./EmergencyContact.vue?vue&type=style&index=0&id=1e23740c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e23740c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e23740c')) {
      api.createRecord('1e23740c', component.options)
    } else {
      api.reload('1e23740c', component.options)
    }
    module.hot.accept("./EmergencyContact.vue?vue&type=template&id=1e23740c&scoped=true", function () {
      api.rerender('1e23740c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/ClientRightSide/EmergencyContact.vue"
export default component.exports